export default "__VITE_ASSET__BmumXFIc__"